import { render, staticRenderFns } from "./AboutBlock.vue?vue&type=template&id=9281b62e&scoped=true&"
import script from "./AboutBlock.vue?vue&type=script&lang=js&"
export * from "./AboutBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutBlock.vue?vue&type=style&index=0&id=9281b62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9281b62e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9281b62e')) {
      api.createRecord('9281b62e', component.options)
    } else {
      api.reload('9281b62e', component.options)
    }
    module.hot.accept("./AboutBlock.vue?vue&type=template&id=9281b62e&scoped=true&", function () {
      api.rerender('9281b62e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/AboutBlock.vue"
export default component.exports